module.exports = __webpack_public_path__ + "img/ic_hive_selected.88d58506.png";